import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ClientCompanyModel } from 'src/Models/ClientCompanyModel';
import { AdminUserType } from 'src/Models/Common';
import { BriefingReportModel, CompanySummaryBriefingFilterModel } from 'src/Models/ReportModel';
import { ReportService } from 'src/Services/report.service';
import { CheckAuth } from 'src/Services/utility.service';
import { UpdatesService } from 'src/Services/updatesService';
import * as FileSaver from 'file-saver';
import { FormGroup, FormControl } from '@angular/forms';
import { MonthlySummaryofDeliveredBriefingsByCompanyModel } from 'src/Models/MonthlySummaryofDeliveredBriefingsByCompanyModel';
import * as moment from 'moment';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-monthly-summary-of-delivered-briefings-by-company',
  templateUrl: './monthly-summary-of-delivered-briefings-by-company.component.html',
  styleUrls: ['./monthly-summary-of-delivered-briefings-by-company.component.css']
})
export class MonthlySummaryOfDeliveredBriefingsByCompanyComponent implements OnInit {
  
  tokenKey: string = '';
  filterModel = new CompanySummaryBriefingFilterModel();
  briefingReports = new Array<BriefingReportModel>();
  dropdownListYears = new Array<{ id: number, text: string }>();
  selectedYear: any;
  dropdownSettingsYear = {};
  dropdownListMonth = new Array<{ id: number, text: string }>();
  selectedMonth: any;
  dropdownSettingsMonth = {};
  clientCompanyList = new Array<ClientCompanyModel>();
  selectedCompany: any;
  dropdownSettingsCompany = {};
  loginuserID: any;
  isloading = false;
  SelectedTool = '';
  systemUserCondition: string = '';

  rangeDates: Date[] = [];
  fromDateFilter: string = '';
  toDateFilter: string = '';

  documentForm = new FormGroup({
    rangeDates: new FormControl(),
  });

  listOfData: MonthlySummaryofDeliveredBriefingsByCompanyModel[];
  listOfDataExport: MonthlySummaryofDeliveredBriefingsByCompanyModel[];

  currentPage: number = 1;
  totalRecordCount: number = -1;
  isAscending: boolean = false
  upDowDisplayDateCSS: string = '';
  upDowTitleCSS: string = '';
  upDowCompanyNameCSS: string = '';
  upDowAccountCSS: string = '';
  upDowIsDemoCSS: string = '';
  upDowIsCompCSS: string = '';
  upDowPriceCSS: string = '';
  upDowTotalBriefingCountCSS: string = '';

  constructor(private readonly checkAuth: CheckAuth, 
    private readonly titleService: Title,
    private readonly reportService: ReportService, 
    private readonly updatesService: UpdatesService,
    private readonly toastrService: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {

    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.loginuserID = this.sessionStorageService.getAdminUserId();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('Company Summary of Delivered Briefings by Company');
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    if (AdminUserType.systemadmin == this.sessionStorageService.getAdminTypeId())
      this.systemUserCondition = 'null'
    else
      this.systemUserCondition = '  (CompanyId IN (Select CompanyId From [SystemUserCompany] Where [SystemUserCompany].UserId = ' + this.loginuserID + '))';

    this.filterModel.orderBy='DisplayDate DESC';
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
  }

  ngOnInit() {
    this.movetotop();
    this.dropdownSettingsYear = {
      singleSelection: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No Year available',
      primaryKey: 'id',
      labelKey: 'text',
      text: 'Select Year',
    };
    this.dropdownSettingsMonth = {
      singleSelection: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No month available',
      primaryKey: 'id',
      labelKey: 'text',
      text: 'Select Month',
    };
    
    this.GetClientCompany();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  getBriefingReport() {
    this.listOfData = [];
    this.isloading = true;
    this.filterModel.isExport=false;
    this.reportService.CompanySummaryDeliveredBriefingsbyCompany(this.tokenKey, this.filterModel).subscribe(data => {
      this.isloading = false;
      if (data) {
        if (data.status == "Success") {
          this.listOfData = data.briefingReports;

          if (this.listOfData.length > 0) {
            this.totalRecordCount = data.briefingReports[0].totalRecord;
          }
          else {
            this.totalRecordCount = 0;
          }
        }
        else {
          this.totalRecordCount = 0;
          this.toastrService.error("Error", "error");
        }
      }
    }, error => {
      this.isloading = false;
    })
  }

  onCompanySelect(selectedCompany) {
    this.filterModel.companyId = 0;
    if (this.selectedCompany.length > 0 && selectedCompany.length != 0) {
      this.filterModel.companyId = this.selectedCompany[0].companyId;
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingReport();
  }

  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  
  GetClientCompany() {
    this.clientCompanyList = [];
    this.updatesService.GetClientCompany(this.tokenKey, 7, this.systemUserCondition).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.clientCompanyList = data['clientCompanay'];
          this.dropdownSettingsCompany = {
            singleSelection: true,
            text: "Select Company",
            enableSearchFilter: true,
            classes: "borderLessTextBoxGreen",
            badgeShowLimit: 2,
            noDataLabel: 'No data available for selected company',
            showCheckbox: false,
            primaryKey: 'companyId',
            labelKey: 'companyName',
            enableFilterSelectAll: false,
          };

          this.selectedCompany = [this.clientCompanyList[0]];
          this.filterModel.companyId = this.clientCompanyList[0].companyId;
          this.setCurrentMonthDateRange();
        }
      },
      error => {
        console.log(error);
      }
    );
  }

 

  transformDate(array) {
    if (array != null) {

      let dd = array.getDate().toString();
      if (parseInt(dd.toString()) < 10)
        dd = '0' + dd.toString();

      let mm = (array.getMonth() + 1).toString();
      if (parseInt(mm.toString()) < 10)
        mm = '0' + mm.toString();

      let hrs = array.getHours();
      if (parseInt(hrs.toString()) < 10)
        hrs = '0' + hrs.toString();

      let min = array.getMinutes()
      if (parseInt(min.toString()) < 10)
        min = '0' + min.toString();

      let sec = array.getSeconds()
      if (parseInt(sec.toString()) < 10)
        sec = '0' + sec.toString();

      return array.getFullYear() + '_' + mm + '_' + dd + '_' + hrs + '_' + min + '_' + sec;
    }
  }

  isDateFilter(dateArray: any) {
    this.rangeDates = dateArray;

    if (this.rangeDates != null) {
      if (this.rangeDates.length > 1) {
        let dd1 = this.rangeDates[0].getDate().toString();
        if (parseInt(dd1.toString()) < 10)
          dd1 = '0' + dd1.toString();

        let mm1 = (this.rangeDates[0].getMonth() + 1).toString();
        if (parseInt(mm1.toString()) < 10)
          mm1 = '0' + mm1.toString();

        let dd2 = this.rangeDates[1].getDate().toString();
        if (parseInt(dd2.toString()) < 10)
          dd2 = '0' + dd2.toString();

        let mm2 = (this.rangeDates[1].getMonth() + 1).toString();
        if (parseInt(mm2.toString()) < 10)
          mm2 = '0' + mm2.toString();

        this.fromDateFilter = this.rangeDates[0].getFullYear() + mm1 + dd1;
        this.toDateFilter = this.rangeDates[1].getFullYear() + mm2 + dd2;
      }
      if (this.fromDateFilter === null || this.fromDateFilter === '') {
        this.fromDateFilter = "null";
        this.toDateFilter = "null";
      }
    }
    else {
      this.fromDateFilter = "null";
      this.toDateFilter = "null";
    }
    if (this.fromDateFilter != 'null' && this.toDateFilter != 'null') {
      this.filterModel.fromDate = this.fromDateFilter;
      this.filterModel.toDate = this.toDateFilter;
      this.filterModel.pageNumber = '1';
      this.currentPage = 1;
      this.getBriefingReport();
    }

  }

  dateFilterClear() {
    this.rangeDates = [];
    this.fromDateFilter = null;
    this.toDateFilter = null;
    this.filterModel.fromDate = null;
    this.filterModel.toDate = null;    
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingReport();
  }

  setCurrentMonthDateRange() {
    const startOfMonth = moment().startOf('month').toDate();
    const endOfMonth = moment().endOf('month').toDate();
    this.rangeDates = [startOfMonth, endOfMonth];
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.getBriefingReport();
  }

  sort(sortBy: any) {
    this.upDowDisplayDateCSS = '';
    this.upDowTitleCSS = '';
    this.upDowCompanyNameCSS = '';
    this.upDowAccountCSS = '';
    this.upDowIsDemoCSS = '';
    this.upDowIsCompCSS = '';
    this.upDowPriceCSS = '';
    this.upDowTotalBriefingCountCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "DisplayDate") {
        this.upDowDisplayDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Title") {
        this.upDowTitleCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CompanyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Account") {
        this.upDowAccountCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "IsDemo") {
        this.upDowIsDemoCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "IsComp") {
        this.upDowIsCompCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Price") {
        this.upDowPriceCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "TotalBriefingCount") {
        this.upDowTotalBriefingCountCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "DisplayDate") {
        this.upDowDisplayDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Title") {
        this.upDowTitleCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CompanyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Account") {
        this.upDowAccountCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "IsDemo") {
        this.upDowIsDemoCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "IsComp") {
        this.upDowIsCompCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Price") {
        this.upDowPriceCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "TotalBriefingCount") {
        this.upDowTotalBriefingCountCSS = 'fa fa-arrow-up';
      }
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingReport();
  }

  getBriefingReportExport() {
    this.listOfDataExport = [];
    this.isloading = true;
    this.filterModel.isExport=true;
    this.reportService.CompanySummaryDeliveredBriefingsbyCompany(this.tokenKey, this.filterModel).subscribe(data => {
      this.isloading = false;
      if (data) {
        if (data.status == "Success") {
          this.listOfDataExport = data.briefingReports;
          setTimeout(() => {
            if (this.listOfDataExport.length > 0) {
              var uri = 'data:application/vnd.ms-excel;base64,'
                , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
                , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
              let html = '<table>';
              if (this.filterModel.companyId && this.selectedCompany) {
                html += "</tr><tr class='mainhead'>    <td colspan='3'> Company: " + this.selectedCompany[0].companyName + "</td>  </tr>";
              }
              html += document.getElementById("reportHeader").innerHTML + " " + document.getElementById("reportBody").innerHTML;
              html += "</table>";
              var ctx = { worksheet: 'Worksheet', table: html }
              let dt = this.transformDate(new Date());
              FileSaver.saveAs((uri + base64(format(template, ctx))), "BriefingReportExport_" + dt + ".xls");
            }
            else {
              this.toastrService.error("No record found", "error");
            }
          }, 1500);
        }
        else {
          this.toastrService.error("Error", "error");
        }
      }
    }, error => {
      this.isloading = false;
    })
  }

  exportToExcel() {
    this.getBriefingReportExport();
  }

}
